import { Record } from 'immutable'

export const ACTIVE = 'active'
export const STALE = 'stale'
export const STATUSES = [ACTIVE, STALE]

export const ChannelAknowledgmentRecord = Record({
  id: null,
  entityId: null,
  aknowledgedAt: null,
})

export const NoteAknowledgmentRecord = Record({
  id: null,
  aknowledgedAt: null,
  entityId: null,
  version: 0,
})

export const ThreadAknowledgmentRecord = Record({
  id: null,
  aknowledgedAt: null,
  noteId: null,
  entityId: null,
})

export function getStatusForEntity(currentUser, entity, fromRegistry) {
  const { lastActivityBy, lastActivityAt, version } = entity
  if (currentUser.get('id') === lastActivityBy) {
    return STALE
  }
  if (new Date(currentUser.get('createdAt')) > new Date(lastActivityAt)) {
    return STALE
  }

  if (!fromRegistry) {
    return ACTIVE
  }
  if (typeof version === 'number' && fromRegistry.version >= version) {
    return STALE
  }
  if (fromRegistry.aknowledgedAt < lastActivityAt) {
    return ACTIVE
  }
  return STALE
}
